import type React from 'react';

import { Button } from '@change/ds-core-ui';

import { useResetCache } from './hooks/useResetCache';

export const PetitionGuideResetCacheButton: React.FC<EmptyProps> = () => {
	const {
		data: { userIsStaff },
		actions: { resetCache },
	} = useResetCache();

	if (!userIsStaff) {
		return null;
	}

	return (
		<div className="container mb-5">
			<Button type="button" onClick={resetCache}>
				Reset Cache (staff view only)
			</Button>
		</div>
	);
};
